import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { fetchAttributesbyid } from "src/api/common";
import {
  handleTransactionNoChange,
  getLeadPaymentPublic,
  createCustomerDraftPayment,
  processReceiptWithAI,
} from "src/api/commonapi";
import PaymentReceiptUpload from "src/views/CommonFunctions/PaymentReceiptUpload";
import { Routes } from "src/constants/api_url";
import {
  CCard,
  CCardBody,
  CCardHeader,
  CCol,
  CRow,
  CForm,
  CFormLabel,
  CFormInput,
  CFormSelect,
  CButton,
  CSpinner,
  CModal,
  CModalBody,
  CModalFooter,
} from "@coreui/react";
import { cilArrowRight } from "@coreui/icons";
import Select from "react-select";
import parse from "html-react-parser";
import CustomImage from "src/views/CommonFunctions/CustomImage";
import cross from "../Customer/cross.jpg";
import moment from "moment";
import "../Customer/extraDocument.scss";
import CIcon from "@coreui/icons-react";

function LeadPaymentPublic() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [submitting, setSubmitting] = useState(false);
  const [leadData, setLeadData] = useState(null);
  const [modes, setModes] = useState([]);
  const [errorMsg, setErrorMsg] = useState("");
  const [aiOcrLoading, setAiOcrLoading] = useState(false);

  const [formData, setFormData] = useState({
    payment_date: moment().format("DD-MM-YYYY"),
    net_amt: "",
    advance_payable_amount: "",
    advance_paid: 0,
    advance_due_amt: 0,
    advance_paid_status: 0,
    due_amt: 0,
    mode_id: 165,
    bank_name: "",
    chk_dd_no: "",
    chk_dd_date: moment().format("DD-MM-YYYY"),
    draft_amount: "",
  });
  // const [receiptUploaded, setReceiptUploaded] = useState(false);

  const [receiptFile, setReceiptFile] = useState(null);
  const [receiptPreview, setReceiptPreview] = useState(null);
  const [receiptPreviewType, setReceiptPreviewType] = useState(null);
  const [txWarning, setTxWarning] = useState(false);
  const [showPopup, setShowPopup] = useState(false);
  const [showErrorModal, setShowErrorModal] = useState(false);
  const [errorModalMessage, setErrorModalMessage] = useState("");

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    setLoading(true);
    try {
      const result = await getLeadPaymentPublic(id);
      if (result.status === 1) {
        setLeadData(result.data);
        const netAmt = result.data?.net_amt || "";
        const draftAmt = result.data?.draftData?.draft_amount || "";
        const advPayableAmt = result.data?.advance_payable_amount || "";
        setFormData((prev) => ({
          ...prev,
          net_amt: netAmt,
          draft_amount: draftAmt,
          advance_payable_amount: advPayableAmt,
          advance_paid: result.data?.advance_paid || 0,
          advance_due_amt: result.data?.advance_due_amt || 0,
          advance_paid_status: result.data?.advance_paid_status || 0,
          due_amt: result.data?.due_amt || 0,
          mode_id: 165,
        }));
      } else {
        if (result.redirect_url) {
          navigate(result.redirect_url);
          return;
        }
        setErrorMsg(result.message || "Invalid payment link");
        setLeadData(null);
      }
      let modeData = await fetchAttributesbyid(15);
      console.log("modeData", modeData);
      let newmode = [];
      modeData &&
        modeData?.map((res) => {
          if (
            // res.attribute_id != 167 &&
            // res.attribute_id != 512 &&
            // res.attribute_id != 160 &&
            // res.attribute_id != 171
            res.attribute_id == 165
          ) {
            newmode.push({
              value: res.attribute_id,
              label: res.name,
            });
          }
        });
      console.log(newmode, "newmode");
      setModes(newmode);
    } catch (err) {
      setErrorMsg("Failed to load payment data");
    }
    setLoading(false);
  };

  const handleFileSelect = async (file) => {
    if (file?.remove) {
      setReceiptFile(null);
      setReceiptPreview(null);
      setReceiptPreviewType(null);
      return;
    }
    setReceiptFile(file);
    if (file.type === "application/pdf") {
      setReceiptPreview(URL.createObjectURL(file));
      setReceiptPreviewType("pdf");
    } else {
      setReceiptPreview(URL.createObjectURL(file));
      setReceiptPreviewType("image");
    }
    // setReceiptUploaded(true);
    setAiOcrLoading(true);
    try {
      const form = new FormData();
      form.append("file", file);
      const ocrResult = await processReceiptWithAI(form);
      if (ocrResult.status === 1 && ocrResult.data) {
        const d = ocrResult.data;
        const updates = {};
        if (d.amount) updates.draft_amount = d.amount;
        if (d.bank_name) updates.bank_name = d.bank_name;
        const cleanVal = (v) =>
          v && v !== "null" && v !== "undefined" && !String(v).includes("@")
            ? v
            : null;
        const ocrTxnId =
          cleanVal(d.utr) ||
          cleanVal(d.transaction_id) ||
          cleanVal(d.reference_number);
        if (ocrTxnId) {
          updates.chk_dd_no = ocrTxnId;
          let isExist = await handleTransactionNoChange(updates.chk_dd_no);
          if (isExist?.data === true) {
            setTxWarning(true);
            setShowPopup(true);
          } else {
            setTxWarning(false);
          }
        }
        // if (d.date) updates.chk_dd_date = d.date;
        // if (d.payment_method) {
        //   const matchedMode = modes.find(
        //     (m) => m.name.toLowerCase() === d.payment_method.toLowerCase()
        //   );
        //   if (matchedMode) updates.mode_id = matchedMode.attribute_id;
        // }
        setFormData((prev) => ({ ...prev, ...updates }));
      }
    } catch (err) {
      console.error("OCR failed", err);
    }
    setAiOcrLoading(false);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!leadData) {
      setErrorMsg(
        "We have sent the updated link in a separate email along with your login credentials. Check your email and use that link to upload your payment screenshot.",
      );
      return;
    }
    if (!receiptFile) {
      setErrorModalMessage("Please upload a payment receipt/screenshot");
      setShowErrorModal(true);
      return;
    }
    if (!formData.draft_amount) {
      setErrorModalMessage("Draft amount is required");
      setShowErrorModal(true);
      return;
    }
    let dueAmt = parseFloat(formData.due_amt || 0);
    if (parseFloat(formData.draft_amount) > dueAmt) {
      setErrorModalMessage("Amount cannot be more than due amount");
      setShowErrorModal(true);
      return;
    }
    if (!formData.chk_dd_no) {
      setErrorModalMessage(
        "The transaction number is missing from the payment screenshot provided. Please upload an updated screenshot that includes the transaction number",
      );
      setShowErrorModal(true);
      return;
    }
    let isExist = await handleTransactionNoChange(formData.chk_dd_no);
    if (isExist?.data === true) {
      setTxWarning(true);
      setShowPopup(true);
      return;
    }
    setSubmitting(true);
    try {
      const submitForm = new FormData();
      submitForm.append("tracking_id", id);
      submitForm.append("payment_date", formData.payment_date);
      submitForm.append("draft_amount", formData.draft_amount);
      submitForm.append("mode_id", formData.mode_id);
      submitForm.append("bank_name", formData.bank_name);
      submitForm.append("chk_dd_no", formData.chk_dd_no);
      submitForm.append("chk_dd_date", formData.chk_dd_date);
      submitForm.append("receiptFile", receiptFile);

      const result = await createCustomerDraftPayment(submitForm);
      if (result.status === 1) {
        navigate(`/lead-payment/thankyou`);
      } else if (result.redirect_url) {
        navigate(result.redirect_url);
      } else {
        setErrorModalMessage(result.message || "Failed to submit payment");
        setShowErrorModal(true);
      }
    } catch (err) {
      setErrorModalMessage("Failed to submit payment");
      setShowErrorModal(true);
    }
    setSubmitting(false);
  };

  if (loading) {
    return (
      <div
        className="d-flex justify-content-center align-items-center"
        style={{ minHeight: "100vh" }}
      >
        <CSpinner />
      </div>
    );
  }

  if (errorMsg && !leadData) {
    return (
      <div
        className="d-flex justify-content-center align-items-center"
        style={{ minHeight: "100vh" }}
      >
        <CCard style={{ width: "500px" }}>
          <CCardBody className="text-center p-5">
            <h4 className="text-danger mb-3">{errorMsg}</h4>
            {/* <p>{errorMsg}</p> */}
          </CCardBody>
        </CCard>
      </div>
    );
  }

  if (leadData?.fully_paid == 1) {
    return (
      <div
        className="d-flex justify-content-center align-items-center"
        style={{ minHeight: "100vh", background: "#f5f7fa" }}
      >
        <CCard style={{ width: "500px" }}>
          <CCardBody className="text-center p-5">
            <div style={{ fontSize: 64, marginBottom: 16 }}>✓</div>
            <h3 className="mb-3">No Due Amount</h3>
            <p className="text-muted mb-0">
              Your payment transaction details have been received successfully
            </p>
          </CCardBody>
        </CCard>
      </div>
    );
  }

  return (
    <>
      <div
        className="d-flex justify-content-center align-items-center"
        style={{ minHeight: "100vh", background: "#f5f7fa", padding: "20px" }}
      >
        <CCard style={{ width: "950px" }}>
          <CCardHeader className="text-center">
            {leadData?.branchData && (
              <div className="mb-2">
                <CustomImage
                  src={`${Routes.API_HOSTNAME}/images/branchlogo/${leadData.branchData.logo}`}
                  width="100px"
                  height="100px"
                  style={{ objectFit: "contain" }}
                />
                <h4 className="mb-0" style={{ margin: "8px 0" }}>
                  {leadData.c_tax == 1
                    ? leadData.branchData.company_name
                    : leadData.branchData.ng_company_name}
                </h4>
              </div>
            )}
            <h5
              className="mb-0"
              style={{
                color: "#003366",
                fontWeight: "bold",
              }}
            >
              Follow the Steps
            </h5>
            <div className="d-flex flex-column flex-md-row justify-content-center align-items-center gap-1">
              <span>
                1. Make the Payment{" "}
                <CIcon
                  icon={cilArrowRight}
                  className="d-none d-md-inline-block"
                />{" "}
              </span>
              <span>
                2. Upload payment screenshot{" "}
                <CIcon
                  icon={cilArrowRight}
                  className="d-none d-md-inline-block"
                />{" "}
              </span>
              <span>3. Submit</span>
            </div>
            {leadData && (
              <small className="text-muted">
                {leadData.l_name_prefix} {leadData.l_name} - {leadData.co_no}
              </small>
            )}
          </CCardHeader>
          <CCardBody>
            <CForm onSubmit={handleSubmit}>
              <CRow>
                <CCol md={6} className="border-start mb-2">
                  <div
                    style={{
                      background: "#bde3c6",
                      padding: "8px 12px",
                      fontWeight: "bold",
                      // borderRadius: 4,
                      marginBottom: 12,
                    }}
                  >
                    Step - 1
                  </div>
                  <>
                    {receiptPreview ? (
                      <div>
                        {/* <CFormLabel className="form-label">
                          Uploaded Receipt:
                        </CFormLabel> */}
                        {receiptPreviewType === "pdf" ? (
                          <iframe
                            src={receiptPreview}
                            title="Receipt Preview"
                            style={{
                              width: "100%",
                              height: 500,
                              border: "1px solid #ddd",
                              borderRadius: 4,
                            }}
                          />
                        ) : (
                          <img
                            src={receiptPreview}
                            alt="Receipt Preview"
                            style={{
                              maxWidth: "100%",
                              maxHeight: 500,
                              objectFit: "contain",
                              border: "1px solid #ddd",
                              borderRadius: 4,
                            }}
                          />
                        )}
                      </div>
                    ) : (
                      leadData?.bankDetail && (
                        <>
                          <CFormLabel
                            style={{ color: "#003366", fontWeight: "bold" }}
                          >
                            Make the payment using the details below
                          </CFormLabel>
                          <div className="bank-detail-content">
                            {parse(
                              (leadData?.bankDetail || "").replace(
                                /<p[^>]*>\s*(?:&nbsp;|\u00a0)?\s*<\/p>/gi,
                                "",
                              ),
                            )}
                          </div>
                        </>
                      )
                    )}
                  </>
                  {aiOcrLoading && (
                    <div
                      className="ai-ocr-loading p-2 mb-2 mt-2"
                      style={{ fontSize: 13 }}
                    >
                      <CSpinner size="sm" /> Extracting data from receipt...
                    </div>
                  )}
                </CCol>
                <CCol md={6}>
                  <div
                    style={{
                      background: "#bde3c6",
                      padding: "8px 12px",
                      fontWeight: "bold",
                      // borderRadius: 4,
                      marginBottom: 12,
                    }}
                  >
                    Step - 2
                  </div>
                  <PaymentReceiptUpload
                    onFileChange={handleFileSelect}
                    from="lead"
                    hidePreview
                  />
                  <CRow className="mb-2 mt-2">
                    <CFormLabel className="col-sm-4 col-form-label">
                      Date
                    </CFormLabel>
                    <div className="col-sm-8">
                      <CFormInput
                        type="text"
                        value={formData.payment_date}
                        disabled
                      />
                    </div>
                  </CRow>
                  {/* <CRow className="mb-1">
                    <CFormLabel className="col-sm-4 col-form-label">
                      Net Amount
                    </CFormLabel>
                    <div className="col-sm-8">
                      <CFormInput
                        type="text"
                        value={formData.net_amt}
                        disabled
                      />
                    </div>
                  </CRow> */}
                  {formData.advance_paid_status == 2 ? (
                    <CRow className="mb-1">
                      <CFormLabel className="col-sm-4 col-form-label">
                        Due Amount
                      </CFormLabel>
                      <div className="col-sm-8">
                        <CFormInput
                          type="text"
                          value={formData.due_amt || 0}
                          disabled
                        />
                      </div>
                    </CRow>
                  ) : formData.advance_paid_status == 1 ? (
                    <CRow className="mb-1">
                      <CFormLabel className="col-sm-4 col-form-label">
                        Advance Due Amount
                      </CFormLabel>
                      <div className="col-sm-8">
                        <CFormInput
                          type="text"
                          value={formData.advance_due_amt || 0}
                          disabled
                        />
                      </div>
                    </CRow>
                  ) : (
                    <CRow className="mb-1">
                      <CFormLabel className="col-sm-4 col-form-label">
                        Advance Amount
                      </CFormLabel>
                      <div className="col-sm-8">
                        <CFormInput
                          type="text"
                          value={formData.advance_payable_amount}
                          disabled
                        />
                      </div>
                    </CRow>
                  )}
                  {/* <CRow className="mb-1">
                    <CFormLabel className="col-sm-4 col-form-label">
                      Advance Payable Amount
                    </CFormLabel>
<div className="col-sm-8">
                      <CFormInput
                        type="text"
                        value={formData.advance_payable_amount}
                        disabled
                      />
                    </div>
                  </CRow> */}
                  {/* <CRow className="mb-2">
                    <CFormLabel className="col-sm-4 col-form-label">
                      Payment Mode
                    </CFormLabel>
                    <div className="col-sm-8">
                      <Select
                        value={modes?.map((u) => {
                          if (u.value == formData.mode_id) {
                            return {
                              value: u.value,
                              label: u.label,
                            };
                          } else return null;
                        })}
                        onChange={(e) => {
                          setFormData((prev) => ({
                            ...prev,
                            mode_id: e.value,
                          }));
                        }}
                        options={modes}
                      />
                    </div>
                  </CRow> */}
                  <CRow className="mb-2">
                    <CFormLabel className="col-sm-4 col-form-label">
                      Draft Amount
                    </CFormLabel>
                    <div className="col-sm-8">
                      <CFormInput
                        type="text"
                        value={formData.draft_amount}
                        disabled
                        placeholder="Auto-filled from receipt"
                      />
                    </div>
                  </CRow>
                  {formData.mode_id != 0 &&
                    formData.mode_id != 160 &&
                    formData.mode_id != 167 && (
                      <>
                        <CRow className="mb-2">
                          <CFormLabel className="col-sm-4 col-form-label">
                            Bank Name
                          </CFormLabel>
                          <div className="col-sm-8">
                            <CFormInput
                              type="text"
                              value={formData.bank_name}
                              disabled
                              placeholder="Auto-filled from receipt"
                            />
                          </div>
                        </CRow>
                        <CRow className="mb-2">
                          <CFormLabel className="col-sm-4 col-form-label">
                            DD/Cheque No
                          </CFormLabel>
                          <div className="col-sm-8">
                            <CFormInput
                              type="text"
                              value={formData.chk_dd_no}
                              disabled
                              placeholder="Auto-filled from receipt"
                            />
                          </div>
                        </CRow>
                      </>
                    )}
                  {/* {formData.mode_id != 0 &&
                    formData.mode_id != 160 &&
                    formData.mode_id != 167 && (
                      <CRow className="mb-2">
                        <CFormLabel className="col-sm-4 col-form-label">
                          DD/Cheque Date
                        </CFormLabel>
                        <div className="col-sm-8">
                          <CFormInput
                            type="date"
                            value={
                              formData.chk_dd_date == undefined ||
                              formData.chk_dd_date == ""
                                ? moment().format("YYYY-MM-DD")
                                : moment(
                                    formData.chk_dd_date,
                                    "DD-MM-YYYY",
                                  ).format("YYYY-MM-DD")
                            }
                            disabled
                          />
                        </div>
                      </CRow>
                    )} */}
                  <div className="row mb-2">
                    <div className="col-sm-4">
                      <div style={{
                        background: "#bde3c6",
                        fontWeight: "bold",
                        padding: "10px 12px",
                        width: "100%"
                      }}>
                        Step - 3
                      </div>

                    </div>
                    <div className="col-sm-8 text-center">
                      <CButton
                        type="submit"
                        color="dark"
                        disabled={submitting}
                        style={{ padding: "8px 40px" }}
                      >
                        {submitting ? (
                          <>
                            <CSpinner size="sm" /> Submitting...
                          </>
                        ) : (
                          "Submit Payment"
                        )}
                      </CButton>
                    </div>
                  </div>
                </CCol>
              </CRow>
            </CForm>
          </CCardBody>
        </CCard>
      </div>
      {aiOcrLoading && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            background: "rgba(0,0,0,0.5)",
            zIndex: 9999,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <div
            className="text-center p-4"
            style={{
              background: "#fff",
              borderRadius: 8,
              minWidth: 250,
            }}
          >
            <CSpinner size="lg" />
            <p className="mt-2 mb-0">Extracting data from receipt...</p>
          </div>
        </div>
      )}
      {showPopup && (
        <CModal backdrop="static" alignment="center" visible={true}>
          <CModalBody>
            <CustomImage src={cross} className="cross_img" />
            <h5 className="d-flex justify-content-center">
              <b className="px-2">{formData.chk_dd_no}</b> Transaction Number
              Already Exists
            </h5>
          </CModalBody>
          <CModalFooter>
            <CButton color="secondary" onClick={() => setShowPopup(false)}>
              Close
            </CButton>
          </CModalFooter>
        </CModal>
      )}
      {showErrorModal && (
        <CModal backdrop="static" alignment="center" visible={true}>
          <CModalBody>
            <CustomImage src={cross} className="cross_img" />
            <h5 className="d-flex justify-content-center text-center text-danger">
              {errorModalMessage}
            </h5>
          </CModalBody>
          <CModalFooter>
            <CButton color="secondary" onClick={() => setShowErrorModal(false)}>
              Close
            </CButton>
          </CModalFooter>
        </CModal>
      )}
    </>
  );
}

export default LeadPaymentPublic;
